import * as React from "react";

import Grid from "@mui/material/Grid";
import { useForm } from "react-hook-form";

import { DurationEmailSchedulerForm, DurationEmailSchedulerProps } from "./types";
import { useStyles } from "./useStyles";

import { DashboardDialog } from "@/dashboard-design-system/Dialog/DashboardDialog";
import { DashboardMenuItem } from "@/dashboard-design-system/MenuItem";
import { DashboardSelect } from "@/dashboard-design-system/Select";
import { DashboardTypography } from "@/dashboard-design-system/Typography/DashboardTypography";
import { useTranslate } from "@/hooks/useTranslate";

const REMINDER_DAYS = Array.from({ length: 29 }, (_, index) => index + 1);

export const DurationEmailScheduler: React.FC<Omit<DurationEmailSchedulerProps, "format">> = ({
  isOpen,
  onCancel,
  cancelLabel,
  onClose,
  onSubmit,
  title,
  label,
  scheduleInDays,
}) => {
  const { t } = useTranslate();
  const classes = useStyles();

  const form = useForm<DurationEmailSchedulerForm>({
    mode: "onChange",
    defaultValues: { scheduleInDays },
  });

  const handleSubmit = form.handleSubmit(async (data) => {
    await onSubmit(data.scheduleInDays);
  });

  return (
    <DashboardDialog
      title={title}
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      classes={{ paper: classes.paper }}
      actions={{
        main: {
          onClick: handleSubmit,
          children: t("common", "confirm"),
        },
        cancel: { children: cancelLabel, onClick: onCancel },
      }}
      hideIcon
    >
      <Grid item xs={12} className={classes.reminderInformation}>
        <Grid container>
          <Grid item xs={12}>
            <Grid container alignItems="center" spacing={1}>
              <Grid item>
                <DashboardTypography variant="body2">{t("dashboard", "common.send")}</DashboardTypography>
              </Grid>
              <Grid item>
                <DashboardSelect
                  control={form.control}
                  name="scheduleInDays"
                  size="small"
                  data-test="duration-email-scheduler"
                >
                  {REMINDER_DAYS.map((value: number) => {
                    return (
                      <DashboardMenuItem key={value} value={value} data-test={`duration-email-scheduler-${value}`}>
                        {`${value}`}
                      </DashboardMenuItem>
                    );
                  })}
                </DashboardSelect>
              </Grid>
              <Grid item>
                <DashboardTypography variant="body2">{label}</DashboardTypography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </DashboardDialog>
  );
};
